import HomeLayout from '../../components/layout/homeLayout';
import cannotSignInImg from '../../assets/images/troubleshooting/cannot-sign-in-my-opswat.png';

import './cannot-sign-in-my-opswat.scss';

const CannotSignInMyOPSWAT = () => {
    return (
        <>
            <HomeLayout pageTitle='OPSWAT Troubleshooting - Cannot sign in to My OPSWAT'>
                <div className='troubleshoot form--wrapper'>
                    <h1 className='title'>Cannot sign into My OPSWAT</h1>
                    <table>
                        <thead>
                            <tr>
                                <th>Term</th>
                                <th>Detail</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='left-column'>Problem</td>
                                <td>Cannot sign into My OPSWAT and be stuck on Sign in/Consent page</td>
                            </tr>
                            <tr>
                                <td className='left-column'>Cause</td>
                                <td>
                                    Cookies are created and saved on browser from the old sign-in workflow/other systems
                                    that don't work with the new sign-in workflow
                                </td>
                            </tr>
                            <tr>
                                <td className='left-column'>Troubleshooting</td>
                                <td>
                                    The error message displays "Your attempt has failed. Please clear your browser
                                    cookies and try again."
                                </td>
                            </tr>
                            <tr>
                                <td className='left-column'>Solution</td>
                                <td>
                                    Clean out your browser's <strong>Cookies</strong> and <strong>Cache</strong> by
                                    following{' '}
                                    <a
                                        target='_blank'
                                        rel='noreferrer'
                                        href='https://support.google.com/accounts/answer/32050?co=GENIE.Platform%3DDesktop&amp;hl=en&amp;oco=0'
                                    >
                                        this guide
                                    </a>{' '}
                                    or using browser Incognito/private mode
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>
                        My OPSWAT just updated the sign-in workflow that allows Single Sign-On to OPSWAT cloud systems.
                    </p>
                    <p>
                        If the user signs in the My OPSWAT and gets the error message, the possible cause is that the
                        cookie are created and saved on browser when the user signed in to My OPSWAT in the past don't
                        work with the new sign-in workflow and needs to be removed.
                    </p>
                    <p>
                        <img src={cannotSignInImg} />
                    </p>
                </div>
            </HomeLayout>
        </>
    );
};

export default CannotSignInMyOPSWAT;
